import React from "react";
import { useLocation } from "react-router-dom";

export const SkipLinks: React.FC = () => {
  const { pathname } = useLocation();
  const hasNavigation = pathname !== "/" && pathname !== "/auth/callback";

  return (
    <nav className="skip-links" aria-label="Skip navigation links">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      {hasNavigation && (
        <a href="#main-navigation" className="skip-link">
          Skip to navigation
        </a>
      )}
    </nav>
  );
};
